import {
  actionTextConversion
} from "./chunk.CD3DSRSX.js";
import {
  emit
} from "./chunk.HM4ZRC4T.js";
import {
  __decorateClass,
  component_styles_default,
  theme_styles_default
} from "./chunk.U4VUMZVF.js";

// src/sub-components/label/label.ts
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/sub-components/label/label.styles.ts
import { css } from "lit";
var label_styles_default = css`
	${theme_styles_default}
	${component_styles_default}

	.label .action-text {
		cursor: pointer;
		color: var(--yotpo-color-brand-70);
		font-weight: var(--yotpo-font-weight-text-medium-regular);
	}

	.label .action-text:hover {
		color: var(--yotpo-color-brand-80);
	}
`;

// src/sub-components/label/label.ts
var YotpoLabel = class extends LitElement {
  constructor() {
    super(...arguments);
    this.text = "";
    this.color = "light" /* light */;
    this.size = "small" /* small */;
    this.hypertext = false;
  }
  get isColorCorrect() {
    return ["light" /* light */, "disabled" /* disabled */, "primary" /* primary */].includes(this.color);
  }
  get isSizeCorrect() {
    return ["small" /* small */, "medium" /* medium */, "large" /* large */].includes(this.size);
  }
  handleActionTextClicked(actionText, event) {
    event == null ? void 0 : event.preventDefault();
    event == null ? void 0 : event.stopPropagation();
    emit(this, "yotpo-link-action" /* linkAction */, { detail: actionText });
  }
  render() {
    return html`
			<div class="yotpo-theme-light">
				<div
					class=${classMap({
      label: true,
      "yotpo-text-small": this.size === "small" /* small */ || !this.isSizeCorrect,
      "yotpo-text-medium": this.size === "medium" /* medium */,
      "yotpo-text-large": this.size === "large" /* large */,
      "yotpo-text-secondary": this.color === "light" /* light */ || !this.isColorCorrect,
      "yotpo-text-primary": this.color === "primary" /* primary */,
      "yotpo-text-disabled": this.color === "disabled" /* disabled */
    })}
				>
					${this.hypertext ? actionTextConversion(this.text, this.handleActionTextClicked.bind(this)) : this.text}
					<slot></slot>
				</div>
			</div>
		`;
  }
};
YotpoLabel.styles = label_styles_default;
__decorateClass([
  property({ reflect: true })
], YotpoLabel.prototype, "text", 2);
__decorateClass([
  property({ reflect: true })
], YotpoLabel.prototype, "color", 2);
__decorateClass([
  property({ reflect: true })
], YotpoLabel.prototype, "size", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoLabel.prototype, "hypertext", 2);
YotpoLabel = __decorateClass([
  customElement("yotpo-label")
], YotpoLabel);
